import { put, call, takeEvery, select } from 'redux-saga/effects'
import { reset, change } from 'redux-form'
import { yesNoModal } from '../../modalsListeners/yesNoModal'
import dossierActionsTypes from '../../../constants/actions/dossier/dossier'
import { dossierTypes as dossierTypesConstant } from '../../../constants/dossier/common/dossierTypes'
import messageModalActions from '../../../actions/modals/messageModal'
import { updateSuppliedsSuccess } from '../../../actions/dossier/sales'
import { hideLoader } from '../../../actions/common'
import { handleError } from '../../errors/errorManager'
import { initializeDossier } from '../commonDossierSagas'
import { v4 as uuidv1 } from 'uuid'
import { updateEconomicPlanFleet } from '../../../actions/management/management'

export function * createSupplied ({ dossierSupplied, resolve, reject, dossierType }) {
  try {
    let stateDossier, economicState, dossierForm, formName, updateFunction

    if (dossierType === dossierTypesConstant.fleetEconomicPlan) {
      stateDossier = yield select(state => state.management.economicPlanModal)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.economicPlanModal.values.dossierEconomicComponent)
      formName = 'economicPlanModal'
      updateFunction = updateEconomicPlanFleet
    } else {
      stateDossier = yield select(state => state.salesDossier)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.salesDossier.values.dossierEconomicComponent)
      formName = 'salesDossier'
      updateFunction = updateSuppliedsSuccess
    }

    let newEconomic = JSON.parse(JSON.stringify(dossierForm))

    // changes(add & delete items changes state not form)
    newEconomic.supplieds = economicState.supplieds
    dossierSupplied.amount = parseFloat(dossierSupplied.amount)
    dossierSupplied.cost = dossierSupplied.amount
    dossierSupplied.dossierId = stateDossier.dossierId
    dossierSupplied.indexFront = uuidv1()
    dossierSupplied.supInvoice = dossierSupplied.supInvoice === '' ? false : dossierSupplied.supInvoice
    newEconomic.supplieds.push(dossierSupplied)

    if (dossierType === dossierTypesConstant.fleetEconomicPlan) {
      yield put(updateFunction(newEconomic))
    } else {
      yield put(updateFunction(newEconomic.supplieds))
    }
    yield put(change(formName, 'dossierEconomicComponent', newEconomic))
    yield put(messageModalActions.openSuccessMessageModal('MESSAGES.POST_TABLE_ITEM_SUCCESS'))
    yield call(resolve)
  } catch (error) {
    const customHandler = function * (customHandlerError) {
      if (customHandlerError.json && (customHandlerError.json.tag === 'DossierOutOfDate' || customHandlerError.json.tag === 'TRANS/DossierOutOfDate')) {
        yield put(hideLoader())
        const confirmedReloadWarning = yield call(yesNoModal, 'DossierOutOfDate')
        if (confirmedReloadWarning) {
          const salesDossierState = yield select(state => state.salesDossier)
          yield call(initializeDossier, dossierTypesConstant.sales, salesDossierState)
        }
      } else {
        yield put(messageModalActions.openErrorMessageModal('MESSAGES.POST_TABLE_ITEM_ERROR', customHandlerError.json ? customHandlerError.json.tag : ''))
      }
      yield call(reject, customHandlerError)
    }
    const sessionHandler = function * () {
      yield put(reset('salesDossier'))
    }
    yield call(handleError, { error, customHandler, sessionHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchCreateSupplied () {
  yield takeEvery(dossierActionsTypes.CREATE_SUPPLIED, createSupplied)
}

export function * deleteSupplied ({ dossierSupplied, dossierType }) {
  try {
    let stateDossier, economicState, dossierForm, formName, updateFunction

    if (dossierType === dossierTypesConstant.fleetEconomicPlan) {
      stateDossier = yield select(state => state.management.economicPlanModal)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.economicPlanModal.values.dossierEconomicComponent)
      formName = 'economicPlanModal'
      updateFunction = updateEconomicPlanFleet
    } else {
      stateDossier = yield select(state => state.salesDossier)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.salesDossier.values.dossierEconomicComponent)
      formName = 'salesDossier'
      updateFunction = updateSuppliedsSuccess
    }

    let newEconomic = JSON.parse(JSON.stringify(dossierForm))

    // changes(add & delete items changes state not form)
    newEconomic.supplieds = economicState.supplieds
    let index = dossierSupplied.id ? newEconomic.supplieds.findIndex(d => d.id === dossierSupplied.id)
      : newEconomic.supplieds.findIndex(d => d.indexFront === dossierSupplied.indexFront)
    newEconomic.supplieds.splice(index, 1)
    if (dossierType === dossierTypesConstant.fleetEconomicPlan) {
      yield put(updateFunction(newEconomic))
    } else {
      yield put(updateFunction(newEconomic.supplieds))
    }
    yield put(change(formName, 'dossierEconomicComponent', newEconomic))
  } catch (error) {
    const customHandler = function * (customHandlerError) {
      if (customHandlerError.json && (customHandlerError.json.tag === 'DossierOutOfDate' || customHandlerError.json.tag === 'TRANS/DossierOutOfDate')) {
        yield put(hideLoader())
        const confirmedReloadWarning = yield call(yesNoModal, 'DossierOutOfDate')
        if (confirmedReloadWarning) {
          const salesDossierState = yield select(state => state.salesDossier)
          yield call(initializeDossier, dossierTypesConstant.sales, salesDossierState)
        }
      } else {
        yield put(messageModalActions.openErrorMessageModal('', customHandlerError.json ? customHandlerError.json.tag : ''))
      }
    }
    const sessionHandler = function * () {
      yield put(reset('salesDossier'))
    }
    yield call(handleError, { error, customHandler, sessionHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchDeleteSupplied () {
  yield takeEvery(dossierActionsTypes.DELETE_SUPPLIED, deleteSupplied)
}

export function * updateSupplied ({ dossierSupplied, resolve, reject, dossierType }) {
  try {
    let stateDossier, economicState, dossierForm, formName, updateFunction

    if (dossierType === dossierTypesConstant.fleetEconomicPlan) {
      stateDossier = yield select(state => state.management.economicPlanModal)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.economicPlanModal.values.dossierEconomicComponent)
      formName = 'economicPlanModal'
      updateFunction = updateEconomicPlanFleet
    } else {
      stateDossier = yield select(state => state.salesDossier)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.salesDossier.values.dossierEconomicComponent)
      formName = 'salesDossier'
      updateFunction = updateSuppliedsSuccess
    }

    let newEconomic = JSON.parse(JSON.stringify(dossierForm))

    // changes(add & delete items changes state not form)
    newEconomic.supplieds = economicState.supplieds
    dossierSupplied.amount = parseFloat(dossierSupplied.amount)
    dossierSupplied.cost = dossierSupplied.amount
    let index = dossierSupplied.id ? newEconomic.supplieds.findIndex(d => d.id === dossierSupplied.id)
      : newEconomic.supplieds.findIndex(d => d.indexFront === dossierSupplied.indexFront)
    newEconomic.supplieds[index] = dossierSupplied
    if (dossierType === dossierTypesConstant.fleetEconomicPlan) {
      yield put(updateFunction(newEconomic))
    } else {
      yield put(updateFunction(newEconomic.supplieds))
    }
    yield put(change(formName, 'dossierEconomicComponent', newEconomic))
    yield call(resolve)
  } catch (error) {
    const customHandler = function * (customHandlerError) {
      if (customHandlerError.json && (customHandlerError.json.tag === 'DossierOutOfDate' || customHandlerError.json.tag === 'TRANS/DossierOutOfDate')) {
        yield put(hideLoader())
        const confirmedReloadWarning = yield call(yesNoModal, 'DossierOutOfDate')
        if (confirmedReloadWarning) {
          const salesDossierState = yield select(state => state.salesDossier)
          yield call(initializeDossier, dossierTypesConstant.sales, salesDossierState)
        }
      } else {
        yield put(messageModalActions.openErrorMessageModal('', customHandlerError.json ? customHandlerError.json.tag : ''))
      }
      yield call(reject, customHandlerError)
    }
    const sessionHandler = function * () {
      yield put(reset('salesDossier'))
    }
    yield call(handleError, { error, customHandler, sessionHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchUpdateSupplied () {
  yield takeEvery(dossierActionsTypes.UPDATE_SUPPLIED, updateSupplied)
}
